import { Route } from "@angular/router";
import { FaqPage } from "./faq.page";

export const FaqRouter: Route[] = [
  { path: 'faq', component: FaqPage }
];
